import { uuid, replaceDomain, SuperTask ,downloadFile} from '@/utils'
import request from '@/utils/request'
import store from '@/store'
import {upload_file} from '@/api/public'
import {portal_upload_download } from '@/api/portal'
import {getToken} from '@/utils/auth'
import Cookies from 'js-cookie'

const state = {
  previewImgDialog: false,
  previewImgUrl: '',
  stsPublic: '/user/sts/public',
  stsInternal: '/user/sts/internal',
  ossRegion: 'oss-cn-guangzhou',

  isPublic: null,
  ossUploadAuth: null, // oss上传凭证
  ossInternalClient: null, // oss私有资源客户端
  ossPublicClient: null, // oss公共资源客户端
  ossInternalAuth: {}, // 私有资源上传凭证
  ossPublicAuth: {}, // 公共资源上传凭证

  retryMaxCount: 3, // 最多重试次数
  retryInterval: 1000, // 重试间隔1000毫秒
  crrRetryCount: 0, // 当前重试次数


  superTask: new SuperTask()
}

const mutations = {

  // 移除文件
  onRemoveFile(state, config) {
    const { target, key, file } = config
    target[key] = target[key].filter(i => i.uid !== file.uid)
  },
  // 图片预览
  openPreviewImg(state, url) {
    state.previewImgUrl = url
    state.previewImgDialog = true
  },
  closePreviewImg(state, show) {
    state.previewImgDialog = show
  },


}

const actions = {
  // 自定义本地上传
  async customLocalUpload({state,commit,dispatch},config){
    return await dispatch('handleUpload',config)
  },
  // 处理本地上传
  async handleUpload({ state, dispatch }, config) {
    let result = null
    const formData = new FormData()
    let crruent = 0
    const fileData = {
      name: config.file.name,
      file: config.file,
      url: '',
      percentage: 0,
      uploading: false
    }
    config.dataList && config.dataList.push(fileData)
    formData.append('file', config.file)
    formData.append('type', config.type)
    await upload_file(formData, {
      onUploadProgress: (progressEvent) => {
        crruent = Math.round(progressEvent.loaded / progressEvent.total * 100)
        crruent = crruent > 90 ? 90 : crruent
        fileData.percentage = crruent
        fileData.uploading = true
      }
    }).then(res => {
      fileData.percentage = 100
      fileData.uploading = false
      result = res.data
      fileData.url = result[0]
    }).catch(() => {
      uploading = false
      fileData.uploading = uploading
    })
    return result
  },
  // 下载本地文件
  async downLocalFile({state},file){
    function normalizedParams(){
      file.downing = true
      file.percentage = 10
      file.name = file.suffix ? file.title + "." + file.suffix : file.name
      return file
    }
    file = normalizedParams()
    const xhr = new XMLHttpRequest()
    xhr.addEventListener('readystatechange', () => {
      if (xhr.readyState === 4) {
        setTimeout(()=>{
          file.downing = false
          file.percentage = 0
        },1000)
        let url = URL.createObjectURL(new Blob([xhr.response]))
        downloadFile(url,file.name)
        URL.revokeObjectURL(url)
      }
    })
    xhr.addEventListener('progress', (e) => {
      file.percentage = (e.loaded / e.total * 100).toFixed(2) - 0
    })
    xhr.responseType = 'blob'
    xhr.open('get', process.env.VUE_APP_BASE_API + '/portal/upload/download'+`?url=${file.url}`)
    xhr.setRequestHeader('Authorization',getToken())
    xhr.setRequestHeader('Site-Host', Cookies.get('domain') || location.host)
    xhr.setRequestHeader('Site-Id', Cookies.get('siteId'))
    xhr.send()
  },
  // 重试私有逻辑
  retryInternal({ state, commit, dispatch }, fileList) {
    console.log('retryInternal')
    commit('setSuperTask')
    state.ossInternalClient = null // 重置client
    clearTimeout(state.retryTimer)
    state.retryTimer = setTimeout(async() => {
      if (state.crrRetryCount >= state.retryMaxCount) {
        return
      }
      state.crrRetryCount++
      dispatch('signatureUrls', fileList)
    }, state.retryInterval)
  },
  async downLocalFile02({ state }, file) {
    file.downing = true
    file.percentage = 10
    const xhr = new XMLHttpRequest()
    xhr.addEventListener('readystatechange', () => {
      if (xhr.readyState === 4) {
        setTimeout(() => {
          file.downing = false
          file.percentage = 0
        }, 1000)
        const url = URL.createObjectURL(new Blob([xhr.response]))
        downloadFile(url, file.name)
        URL.revokeObjectURL(url)
      }
    })
    xhr.addEventListener('progress', (e) => {
      file.percentage = (e.loaded / e.total * 100).toFixed(2) - 0
    })
    xhr.responseType = 'blob'
    xhr.open('get', process.env.VUE_APP_BASE_API + '/upload/download' + `?url=${file.url}`)
    xhr.setRequestHeader('Authorization', getToken())
    xhr.setRequestHeader('Site-Host', localStorage.getItem('domain') === 'null' || !localStorage.getItem('domain') ? location.host : localStorage.getItem('domain'))
    xhr.setRequestHeader('Site-Id', localStorage.getItem('siteId') || null)
    xhr.send()
  },


  // 自定义上传
  async customOssUploadRequest({ state, commit, dispatch }, config) {
    console.log('customOssUploadRequest')
    return state.superTask.add(() => dispatch('handleSuperTask', config))  // 丢到任务控制器按顺序执行
  },
  // 处理任务队列
  handleSuperTask({ state, commit, dispatch }, config) {
    state.isPublic = config.url === state.stsPublic
    return new Promise(async (resolve, reject) => {
      await dispatch('handleOssUpload', config).then(ossUploadRes => {
        dispatch('handleOssUploadRes', { ossUploadRes, config }).then(() => {
          resolve(ossUploadRes)
        })
      })
    })
  },
  // 处理oss上传
  async handleOssUpload({ state, dispatch }, config) {
    let res = null
    const fileDir = await dispatch('createOssFileDir', config)
    // 创建客户端
    await dispatch('createOssClient', config).then(async ossClient => {
      try {
        res = await ossClient.put(fileDir, config.file)  // 上传到阿里oss
        if (state.isPublic) {
          res.url = process.env.VUE_APP_oss_pub_domain + res.name
        } else {
          // 对私有资源签名
          res.previewUrl = replaceDomain(process.env.VUE_APP_oss_internal_domain, await ossClient.signatureUrl(res.name))
        }
      } catch (error) {
        console.log('ossClient-err', error)
      }
    })
    return res
  },
  // 获取oss文件存储目录
  createOssFileDir({ state }, config) {
    console.log('createOssFileDir')
    return `${config.path}/${uuid(16)}.${config.file.name.match(/[a-z]+$/g)}` // oss文件目录，文件名 Sitemanagement/logo/1640825856858.jpeg
  },
  // 处理oss上传结果
  handleOssUploadRes({ state }, { ossUploadRes, config }) {
    console.log('handleOssUploadRes')
    // 设置文件数据
    config.dataList.push({
      ossname: ossUploadRes.name,
      previewUrl: ossUploadRes.previewUrl || ossUploadRes.url,
      uid: config.file.uid,
      name: config.file.name,
      url: (state.isPublic ? process.env.VUE_APP_oss_pub_domain : process.env.VUE_APP_oss_internal_domain) + ossUploadRes.name
    })
    state.crrRetryCount = 0 // 重置重试次数
  },
  // 获取oss上传凭证（）
  async getOssUploadAuth({ state }, url) {
    console.log('getOssUploadAuth', url)
    const { data } = await request({ url: url })
    if (state.isPublic) {
      state.ossPublicAuth = data
    } else {
      state.ossInternalAuth = data
    }
    return data
  },
  // 创建oss客户端
  async createOssClient({ state, commit, dispatch }, config) {
    console.log('createOssClient')
    let clientKey = ''
    if (state.isPublic) {
      clientKey = 'ossPublicClient'
      if (state.ossPublicClient && await dispatch('validPublicExpiration')) {
        return state.ossPublicClient
      }
    } else {
      clientKey = 'ossInternalClient'
      if (state.ossInternalClient && await dispatch('validInternalExpiration')) {
        return state.ossInternalClient
      }
    }
    console.log('凭证已过期，或ossClient不存在')
    await dispatch('getOssUploadAuth', config.url).then(ossUploadAuth => {
      state[clientKey] = new OSS({ // 创建oss实例
        region: state.ossRegion,
        accessKeyId: ossUploadAuth.accessKeyId,
        accessKeySecret: ossUploadAuth.accessKeySecret,
        stsToken: ossUploadAuth.securityToken,
        bucket: config.bucket, //
        refreshSTSToken: async () => {
          return await dispatch('getOssUploadAuth', config.url)
        }
      })
    })
    return state[clientKey]
  },
  // 私有资源凭证是否过期
  validPublicExpiration({ state }) {
    return new Date().getTime() < new Date(state.ossPublicAuth.expiration).getTime()
  },
  // 公共资源凭证是否过期
  validInternalExpiration({ state }) {
    return new Date().getTime() < new Date(state.ossInternalAuth.expiration).getTime()
  },

  // 对私有资源签名
  async signatureUrls({ state, dispatch }, fileUrl) {
    const arr = []
    if (fileUrl && fileUrl.length && Object.prototype.toString.call(fileUrl) === '[object Array]') {
      await dispatch('createOssClient', { url: state.stsInternal, bucket: process.env.VUE_APP_Bucket_internal }).then(async ossClient => {
        for (const v of fileUrl) {
          try {
            if (v.name) {
              arr.push({
                previewUrl: replaceDomain(process.env.VUE_APP_oss_internal_domain, await ossClient.signatureUrl(v.url.replace(/.*.com\//, ''))), // 截取oss前缀
                url: v.url,
                name: v.name
              })
            } else {
              arr.push({
                previewUrl: replaceDomain(process.env.VUE_APP_oss_internal_domain, await ossClient.signatureUrl(v.replace(/.*.com\//, ''))), // 截取oss前缀
                url: v,
              })
            }
            state.crrRetryCount = 0
          } catch (err) {
            setTimeout(async () => {
              console.log('signatureUrls', err)
              await dispatch('signatureUrls', fileUrl)
              state.crrRetryCount++
            }, state.retryInterval)
          }
        }
      })
    }
    return arr
  },
  // 文件下载
  async openPreviewFile({state,dispatch}, config) {
    const isPublic = config.url === state.stsPublic
    let previewUrl = ''
    await dispatch('createOssClient', { url: config.url, bucket: config.bucket }).then(async ossClient => {
      try {
        previewUrl = replaceDomain(isPublic ? process.env.VUE_APP_oss_pub_domain : process.env.VUE_APP_oss_internal_domain, await ossClient.signatureUrl(config.file.url.replace(/.*.com\//, '')), {
          response: {
            'content-disposition': `filename=${config.file.name}`
          }
        })
        state.crrRetryCount = 0 // 重置重试次数
      } catch (err) {
        console.log('openPreviewFile', err)
      }
    })
    window.open(previewUrl, '_blank')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

